import {AoflElement, customElement, property} from '@aofl/element';
import Cookies from 'js-cookie';
import {accessibilityMixin} from '../../modules/accessibility-mixin';
import {clickTrackerMixin} from '../../modules/click-tracker-mixin';
import {cookies} from '../../modules/constants-enumerate';
import {ModalService} from '../../modules/modal-service';
import template from './template';
import styles from './template.css';

/**
 * @summary UpdatedFooter
 * @extends {AoflElement}
 */
@customElement('updated-footer')
class UpdatedFooter extends clickTrackerMixin(accessibilityMixin(AoflElement)) {
  /**
   * @readonly
   */
  static is = 'updated-footer';

  @property({type: Number})
  currentYear = (new Date()).getFullYear();

  @property({type: Boolean, attribute: 'show-logout'})
  showLogout = false;

  @property({type: Boolean})
  showDoNotSellMyInfo = ((Cookies.get(cookies.COUNTRY_CODE) === 'US') && (Cookies.get(cookies.REGION) === 'CA'));

  /**
   *
   */
  showCookieConsentModal(e) {
    e.preventDefault();
    ModalService.show('cookieConsentModal');
  }

  /**
   *
   */
  async firstUpdated() {
    super.firstUpdated();

    await this.updateComplete;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default UpdatedFooter;
